module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 snippet-title",
    attrs: {
      "id": _vm.title
    }
  }, [_c('h3', {
    staticClass: "ex-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.desc) ? _c('h5', {
    staticClass: "ex-desc",
    domProps: {
      "innerHTML": _vm._s(_vm.desc)
    }
  }) : _vm._e(), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "btn btn-default btn-jsfiddle",
    attrs: {
      "href": _vm.fiddlelink,
      "target": "_blank"
    }
  }, [_vm._v("Try it with JSfiddle")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-sm-12 col-xs-12 snippet"
  }, [_c('pre', [_vm._v("\n        "), _c('code', {
    directives: [{
      name: "hljs",
      rawName: "v-hljs"
    }],
    staticClass: "xml",
    domProps: {
      "textContent": _vm._s(_vm.snippet)
    }
  }), _vm._v("\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "demo"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("external")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9cbf39d8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Example.vue
// module id = 17
// module chunks = 0